import React from 'react';
var DisplayManagerContext = React.createContext(null);
export var DisplayManagerProvider = DisplayManagerContext.Provider;
export var DisplayManagerConsumer = DisplayManagerContext.Consumer;
export default DisplayManagerContext;
//# sourceMappingURL=display-manager-context.js.map